module.exports = __webpack_public_path__ + "assets/img/移动端红.7ad1f751.png";